import { inject } from "@angular/core";
import { FeatureFlagService } from "@app/modules/feature-flag/feature-flag.service";
import { FeatureFlags } from "@app/modules/feature-flag/feature-flags.model";

export const canMatchMyData = () => {
  return inject(FeatureFlagService).isFlagEnabled(FeatureFlags.MY_DATA_ENABLED);
}